import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  { id: "assessment", label: "Assessment Offers" },
  { id: "system", label: "Growth System" },
  { id: "packages", label: "Marketing Packages" },
  { id: "products", label: "Digital Products" },
  { id: "consulting", label: "Consulting" },
  { id: "guarantee", label: "Guarantee" },
  { id: "faq", label: "FAQ" },
];

const LEGAL = [
  { to: "/intake?type=consultation", label: "Book a Consultation", testid: "footer-link-consultation" },
  { to: "/privacy", label: "Privacy Policy", testid: "footer-link-privacy" },
  { to: "/terms", label: "Terms of Service", testid: "footer-link-terms" },
  { to: "/refund-policy", label: "Refund Policy", testid: "footer-link-refund" },
];

export const Footer = () => (
  <footer className="relative border-t border-slate-800/70 bg-obsidian-900/60 pt-16 pb-10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Wordmark />
          <p className="font-display font-bold text-gold mt-5">Assess. Build. Grow. Scale.</p>
          <p className="text-slate-400 text-sm mt-3 leading-relaxed max-w-sm">
            Digital Marketing · SEO · Content · Websites · Lead Generation · Automation · AI ·
            Analytics · Software Integration
          </p>
          <p className="text-slate-300 text-sm mt-5">
            <a href="mailto:allinhand@zohomail.com" data-testid="footer-contact-email" className="hover:text-gold underline underline-offset-4 decoration-gold/40 transition-colors">
              allinhand@zohomail.com
            </a>
          </p>
          <p className="text-slate-400 text-sm mt-2">allinhandmarketing.com</p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500 mb-5">Explore</p>
          <div className="flex flex-col gap-3">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`footer-nav-${n.id}`}
                onClick={() => scrollToId(n.id)}
                className="text-left text-sm text-slate-400 hover:text-gold transition-colors"
              >
                {n.label}
              </button>
            ))}
          </div>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500 mb-5">Company</p>
          <div className="flex flex-col gap-3">
            {LEGAL.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className="text-sm text-slate-400 hover:text-gold transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-14 rounded-2xl border border-slate-800/80 bg-obsidian-800/40 p-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold/80 mb-3">
          Important Notice
        </p>
        <p className="text-slate-400 text-xs leading-relaxed">
          Marketing, advertising, business, AI, software, and Web3 services involve varying levels of
          risk and performance. Past results, examples, projections, estimates, or case studies do not
          guarantee future outcomes. Customers remain responsible for their business decisions,
          regulatory obligations, accounts, advertising budgets, and approval of final materials.
        </p>
      </div>

      <p className="text-slate-400 text-xs text-center mt-10">
        © All In Hand Marketing. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
